export class PositionOverviewFilter {
    hedgeDateFrom?: string;
    hedgeDateTo?: string;
    executionDateFrom?: string;
    executionDateTo?: string;
    companyCodes?: string[];
}
